import { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Stamp } from "../components-atoms";
import { IStampProps } from "../components-atoms/Stamp";
import { ITheme } from "../constants/theme";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

const CardEndArea = (props: any) => {
  return (
    <Grid container item xs={props?.thirdGrid ?? 4}>
      {props?.children}
    </Grid>
  );
};

export const InfoCard = (props: any) => {
  const classes = useStyles();
  const { data, showMoreEnabled = false } = props;
  const CardImage = props.cardImage;
  const [expanded, setExpanded] = useState(false);
  const showMore = showMoreEnabled && data?.bottomText?.length > 200;

  const renderStamp = () => {
    let stampProps: IStampProps = {};
    if (data?.IsBinded !== undefined && !data?.IsBinded) {
      stampProps = {
        type: "warning",
        text: "Unassigned",
      };
    }
    if (data?.IsReferralVoucher) {
      stampProps = {
        type: "primary",
        text: "Referral Voucher",
      };
    }
    if (data?.IsShopInactive) {
      stampProps = {
        type: "fail",
        text: "Inactive",
      };
    }
    if (data.stamp) {
      stampProps = {
        text: data.stamp,
      };
    }

    return stampProps?.text?.length! > 0 ? <Stamp {...stampProps} /> : null;
  };

  return (
    <Box
      onClick={(e) => props.onClick && props.onClick(data, e)}
      className={classes.container}
    >
      <Container
        className={`${props?.disabled ? classes.rootDisabled : classes.root} ${props.className}`}
      >
        {props?.firstGrid && (
          <Grid container xs={props?.firstGrid ?? 1}>
            <CardImage />
          </Grid>
        )}
        <Grid
          item
          container
          xs={props?.secondGrid ?? 8}
          justifyContent="center"
        >
          <Grid item container>
            <Typography variant="h6" component="h3" color="textPrimary">
              {data?.topText ?? ""}
            </Typography>
            {renderStamp()}
          </Grid>
          {data?.body && (
            <Grid item container className={classes.bodyText}>
              <Typography variant="body1" component="span" color="textPrimary">
                {data?.body}
              </Typography>
            </Grid>
          )}
          <Grid item container className={classes.gridMargin}>
            <Typography variant="body2" component="span" color="textSecondary">
              {showMore ? expanded ? data?.bottomText : data?.bottomText.slice(0, 200) + "..." : data?.bottomText ?? ""}
            </Typography>
            {showMore &&
              <Typography
                variant="body2"
                color="primary"
                className={classes.showMore}
                onClick={() => setExpanded(e => !e)}>
                {expanded ? " Show less" : " Show more"}
              </Typography>
            }
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={props?.thirdGrid ?? 4}
          justifyContent="flex-end"
        >
          {props?.children}
        </Grid>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    marginBottom: "24px",
  },
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 16px 24px 24px ",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "all 200ms ease",
    ...textButtonHoverAndActive
  },
  rootDisabled: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 16px 24px 24px ",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  gridMargin: {
    marginTop: "5px",
  },
  bodyText: {
    paddingTop: 8,
    paddingBottom: 16,
  },
  showMore: {
    cursor: "pointer"
  }
}));
InfoCard.EndArea = CardEndArea;
